class Logger {
  static get() {
    if (this.instance instanceof Logger) {
      return this.instance;
    }

    this.instance = new Logger({ prefix: 'CMS' });
    
    return this.instance;
  }
  constructor(options) {
    const { prefix = 'LOGGER' } = options;
    
    this.prefix = prefix;
  }
  
  log(...args) {
    console.log(`[${this.prefix}]`, ...args);
  }
  
  error(...args) {
    console.error(`[${this.prefix}]`, ...args);
  }
}

export default Logger;
